module.exports = __webpack_public_path__ + "img/home_logo.252b8ffd.png";